import { render, staticRenderFns } from "./CredentialsComponent.vue?vue&type=template&id=27c48693&"
import script from "./CredentialsComponent.vue?vue&type=script&lang=js&"
export * from "./CredentialsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports